import React from 'react';
import { Card, CardContent } from '@frontend/shadcn/components/ui/card';
import { P } from '@frontend/shadcn/components/typography/p';
import { H3 } from '@frontend/shadcn/components/typography/h3';

interface ISectionCardProps {
  children?: React.ReactNode;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  description?: React.ReactNode;
  rightContent?: React.ReactNode;
}

export const SectionCard: React.FC<ISectionCardProps> = ({
  children,
  icon,
  title,
  subtitle,
  description,
  rightContent,
}) => (
  <Card className="border border-border shadow-none">
    <CardContent className="p-6">
      <div className="flex flex-col gap-6">
        {(icon || subtitle || title || description || rightContent) && (
          <div className="flex flex-row justify-between items-center">
            <div className="flex flex-col">
              {(icon || subtitle) && (
              <div className="flex items-center gap-2">
                {icon}
                {subtitle && <P className="mb-0">{subtitle}</P>}
              </div>
            )}
              {title && <H3 className="font-medium mb-0">{title}</H3>}
              {description && <P className="text-primaryMuted">{description}</P>}
            </div>
            {rightContent && rightContent}
          </div>
        )}
        {children}
      </div>
    </CardContent>
  </Card>
);
